<template>
    <section class="bg-white dark:bg-slate-800 shadow dark:shadow-slate-900/50 rounded-lg col-span-12 md:col-span-6">
        <div class="p-6 flex flex-col items-center text-center">
            <!-- Illustration -->
            <div class="mb-4 relative">
                <img
                    src="/images/companionpass/graphics-companionpass-default.png"
                    alt="Southwest Companion Pass"
                    style="width: 212px; height: 162px"
                />
                <div
                    class="hidden dark:block absolute inset-0 pointer-events-none"
                    style="
                        background: radial-gradient(
                            ellipse 72% 72% at 50% 45%,
                            transparent 40%,
                            #1e293b 84%
                        );
                    "
                ></div>
            </div>

            <!-- Title -->
            <h1 class="font-semibold text-slate-800 dark:text-slate-100" style="font-size: 30px; line-height: 36px">
                <span class="text-orange">Companion Pass</span>
                — fly<br>
                together, save
                <span class="text-orange">more!</span>
            </h1>

            <!-- Description -->
            <p class="mt-2 text-sm font-normal text-slate-500 dark:text-slate-400 leading-5">
                With the Companion Pass, your next adventure just got twice as exciting —<br>
                for half the cost! Don’t wait, start earning your pass today.
            </p>

            <!-- Enable button -->
            <div
                class="pt-6"
                v-if="canShow && (settingsPage || !fiveTwentyFour || canDismiss524Alert)"
            >
                <button
                    type="button"
                    class="inline-flex items-center justify-center px-4 py-2.5 text-sm font-medium text-white rounded shadow-sm"
                    style="background: #FD421D"
                    @click="toggle"
                    :disabled="fiveTwentyFour"
                    id="hs-dashboard-companion-pass-toggle"
                >
                    Enable companion pass mode
                </button>
                <input
                    type="text"
                    class="hidden"
                    v-model="passEnabled"
                    name="card_status"
                />
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useAppStore } from '@/store/app';
import { useCompanionPassStore } from '@/store/companionpass';
import Icon from '@/components/ui/icon/icon.vue';

export default {
    name: 'CompanionPassSection',
    components: { Icon },
    props: {
        settingsPage: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    watch: {
        passEnabled() {
            this.userSettings.companion_pass = this.passEnabled;
        },
    },
    computed: {
        ...mapState(useAppStore, ['userSettings']),
        ...mapState(useCompanionPassStore, [
            'passEnabled',
            'fiveTwentyFour',
            'fiveTwentyFourModal',
        ]),
        canShow() {
            if (this.settingsPage) {
                return true;
            }
            return !this.fiveTwentyFour || this.canDismiss524Alert;
        },
    },
    methods: {
        ...mapActions(useAppStore, ['setShowAffiliateModal']),
        ...mapActions(useCompanionPassStore, [
            'getPassData',
            'togglePass',
            'setPassEnabled',
        ]),
        toggle() {
            this.setPassEnabled(!this.passEnabled);
            this.togglePass();
        },
    },
};
</script>
